import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TARGET_TABLE } from '../../../../../../../../../../webcomponents.constants';
import { GzPolicyUiSettingsTableWebComponent } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { getTableColumns } from './grid-config';
import { html, TemplateResult } from 'lit';
import { GRID_ITEM_FORM_ID } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/base/component/GzPolicyUiSettingsBaseGrid';
import { AntimalwareOnDemandScanTarget } from '@nirvana/shared/dtos/types/policies/common';
import { ValidationResult } from '../../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { validateDuplicates } from './utils/validators';

@customElement(WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TARGET_TABLE)
export class GzAntimalwareOnDemandScanTargetTableWebComponent extends GzPolicyUiSettingsTableWebComponent<
  AntimalwareOnDemandScanTarget,
  AntimalwareOnDemandScanTarget
> {
  protected hasReorderRowAction = false;
  protected columns = getTableColumns();

  protected renderGridItemForm(): TemplateResult {
    return html` <gz-policy-panel-antimalware-on-demand-scan-target-item
      id="${GRID_ITEM_FORM_ID}"
      style="padding-bottom: 25px;"
    ></gz-policy-panel-antimalware-on-demand-scan-target-item>`;
  }

  protected validateGridItemBeforeAdd(gridItemFormValue: AntimalwareOnDemandScanTarget): ValidationResult {
    // check for duplicates
    return validateDuplicates(gridItemFormValue, this.gridComponent.getFormValue());
  }

  protected validateGridItemBeforeEdit(
    oldItem: AntimalwareOnDemandScanTarget,
    newItem: AntimalwareOnDemandScanTarget
  ): ValidationResult {
    // skip if item is not changed
    if (newItem.path === oldItem.path) {
      return { valid: true };
    }

    return this.validateGridItemBeforeAdd(newItem);
  }
}
